import { RequestError } from "../requestError";
import api from "../axiosBase";
import { getURL } from "../serviceHelper";
import { getEnv } from "../../AppConfigs";

const SPSiteId = getEnv("REACT_APP_SP_SITE_ID");
const SPListId = getEnv("REACT_APP_DOCUMENT_TEMPLATES_LIST_ID");

const expand =
  "expand=fields(select=id,Title,IsActive,CategoryLookupId)";

export class DocumentTemplateService {
  static async getList(isActive: any = undefined) {

    const filter = isActive !== undefined ? `&filter=fields/IsActive eq ${isActive ? 1 : 0}` : "";

    const url = `/sites/${SPSiteId}/lists/${SPListId}/items?${expand}${filter}`;;
    return api
      .get(getURL(url))
      .then((res) => {
        return res.data?.value?.map((item: any) => (this.mapData(item)));
      })
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async get(id: any) {
    const url = `/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&filter=fields/id eq ${id}`;;
    return api
      .get(getURL(url))
      .then((res) => {
        if(res.data.length > 0)
          return this.mapData(res.data[0]);
        return null;
      })
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async create(fields: any) {
    return api
      .post(
        getURL(`/sites/${SPSiteId}/lists/${SPListId}/items`),
        { fields }
      )
      .then((res) => this.mapData(res.data))
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async update(id: any, fields: any) {
    return api
      .patch(
        getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}/fields`),
        fields
      )
      .then((res) => res.data)
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async delete(id: any) {
    return api.delete(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}`))
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }

  static mapData(item: any) { 
    return {
      Id: item.fields.id,
      Title: item.fields.Title,
      IsActive: item.fields.IsActive,
      CategoryLookupId: item.fields.CategoryLookupId
    }
  }
}
